import QuickJobsApi, { IPaginationParams } from ".";

interface ICollectionParams extends IPaginationParams {
  search?: string;
}

class Jobs {
  protected client: QuickJobsApi;

  constructor(client: QuickJobsApi) {
    this.client = client;
  }

  public getAllJobs(
    params?: ICollectionParams & {
      term?: "one_time" | "long_term" | "full_time";
    }
  ) {
    return this.client.httpClient.get("/jobs", {
      params: {
        ...params
      }
    });
  }

  public getJob(id: number) {
    return this.client.httpClient.get(`/jobs/${id}`);
  }

  public ban(id: number) {
    return this.client.httpClient.post(`/jobs/${id}/ban`);
  }

  public cancel(id: number) {
    return this.client.httpClient.put(`/jobs/${id}/cancel`);
  }
}

export default Jobs;



// WEBPACK FOOTER //
// ./src/libs/quickjobs-api/jobs.ts